import { useLocation } from "react-router-dom";
import { companySections } from "../  config/sectionsConfig";
import { usePermission } from "../utils/permissions";

export function useCompanyLabelsControllers(accountType: "company" | "individual") {
    const location = useLocation();
    const { can } = usePermission();

    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab") || "profile";

    const allTabs = [
        {
            label: "Company Profile",
            value: "profile",
            description:
                accountType === "company"
                    ? "Manage your company’s core details and branding"
                    : "Manage your personal details and profile information",
        },
        {
            label: accountType === "company" ? "Roles & Permission" : "Roles & Access",
            value: "roles",
            description:
                accountType === "company"
                    ? "Define team roles and permissions to control access levels and responsibilities."
                    : "Manage access roles and permissions for your personal account",
        },
        {
            label: "Subscription",
            value: "subscription",
            description:
                accountType === "company"
                    ? "Manage billing, plans, and invoices"
                    : "Manage your subscription and billing preferences",
        },
        {
            label: "Security",
            value: "security",
            description: "Set up password rules and access policies",
        },
        {
            label: "Notifications",
            value: "notifications",
            description: "Configure email and system alerts",
        },
    ];

    const tabs = allTabs.filter(
        (tab) => tab.value !== "subscription" || can("view subscription")
    );

    return {
        tabs,
        sections: companySections,
        tabParam,
    };
}

